/*global BMap BMapLib*/

import { makeMarkerHtml } from "@utils/utils";
import { myConst, myFn, myMap } from "@config/";
import rootStore from "@store/";
const { appStore, dataStore, mapStore } = rootStore;

const mapData = {
    noLocMarker: "",
    succMarker: "", // 我的位置 Marker 定位时赋值
    circle: "", // 我的定位位置 范围圈 定位时赋值
    singleTap: 0, // 地图每次点击次数 单击还是双击
    mapClickEventTimer: "", // 地图点击事件定时器 用来判断单击还是双击还是啥
    nearMarker: [],
    lastCenterLoc: { // 初始值为经纬度 后覆盖为百度地图 Point 类
        lat: 0,
        lng: 0,
    },
};
mapData.lastCenterLoc = new BMap.Point(mapData.lastCenterLoc.lng, mapData.lastCenterLoc.lat);


export function init() {
    console.log('map Init');
    if (!appStore.initState.page) {
        // 第一次 初始化
        findAndPin(mapStore.defaultLoc.bLoc);
    } else {
        myMap.map.clearOverlays();
        let centerPoint = myMap.map.getCenter();
        mapData.nearMarker = [];
        findAndPin(centerPoint);
    }
}
export function findAndPin(centerPoint) {
    const onMapList = dataStore.onMapList;
    let disArr = onMapList.map((v, i) => ({
        item: v,
        dis: myMap.map.getDistance(v.bLoc, centerPoint),
    }));
    disArr.sort((a, b) => {
        // if ((a.dis - b.dis).toString() == "NaN") console.log(a, b);
        return a.dis - b.dis;
    });
    if (disArr.length >= myConst.maxShowInMap) disArr.length = myConst.maxShowInMap;
    disArr = disArr.map(v => v.item);
    // 优化 减少 Dom CRUD
    const addPinMarkerArr = [];
    const onMapMarkerArr = [];
    const removePinMarkerArr = [];
    // 找出新增的 marker 和地图上已有的 marker
    for (let i = 0; i < disArr.length; i++) {
        const disMarker = disArr[i];
        let flag = false;
        for (let j = 0; j < mapData.nearMarker.length; j++) {
            let nMarker = mapData.nearMarker[j];
            if (nMarker.id == disMarker.id) {
                flag = true;
                break;
            }
        }
        if (flag == false) {
            // 在地图上没找到一样的，说明这是要新增的
            addPinMarkerArr.push(disMarker);
        } else {
            onMapMarkerArr.push(disMarker);
        }
    }
    myFn.pin(addPinMarkerArr);
    // 找出需要删除的
    for (let i = 0; i < mapData.nearMarker.length; i++) {
        let nMarker = mapData.nearMarker[i];
        let flag = false;
        for (let j = 0; j < onMapMarkerArr.length; j++) {
            let onMapMarker = onMapMarkerArr[j];
            if (nMarker.id == onMapMarker.id) {
                flag = true;
                break;
            }
        }
        if (flag == false) {
            // 没找，说明这是要删除的
            removePinMarkerArr.push(nMarker);
        }
    }
    removePinMarkerArr.forEach((v) => {
        myMap.map.removeOverlay(v.marker);
    });
    // 如果 infoBox 已经打开，但是 marker 不在范围 则关闭 infobox
    let openInfoMarkerId = mapStore.win.infoBox.openMarkerId;
    let openInfoBoxFlag = disArr.some((v) => {
        return openInfoMarkerId == v.id;
    });
    if (!openInfoBoxFlag && mapStore.win.infoBox._isOpen) {
        mapStore.toggleInfoBox({ source: 'findAndPin', on_off: false });
    }
    // 保存附近的marker
    mapData.nearMarker = disArr;
}

export function pin(arr) {
    const map = myMap.map;
    const icon = new BMap.Icon("./static/img/dot.jpg", new BMap.Size(41, 30));
    console.red('Add pin Marker', arr.length);
    arr.forEach((v, i) => {
        if (!v.marker) {
            const marker = new BMap.Marker(v.bLoc, { icon });
            const label = new BMap.Label();
            const html = makeMarkerHtml(v, 'pin');
            label.setContent(html);
            label.setOffset(new BMap.Size(0, -30));
            label.setStyle({
                backgroundColor: "rgba(255, 255, 255, 0)",
                border: 0,
            });
            v.label = label;
            v.marker = marker;
        }
        v.marker.setLabel(v.label);
        map.addOverlay(v.marker);
    });
}
export function getMyLocInit() {
    // 创建一个未定位标记
    mapData.noLocMarker = new BMap.Marker(mapStore.defaultLoc.bLoc, {
        title: "我的位置",
        enableMassClear: false,
        icon: new BMap.Icon("./static/img/noLoc.png", new BMap.Size(16, 16)),
    });
    myMap.map.addOverlay(mapData.noLocMarker);
    myMap.geolocation = new BMap.Geolocation();
    // 定位回调函数赋值
    myMap.geolocation.getLoc = function () {
        if (appStore.locState.isLocIng) return;
        appStore.changeIsLocIng(true);
        myMap.geolocation.getCurrentPosition(function (position) {
            let myLoc = mapStore.myLoc;
            // eslint-disable-next-line
            if (this.getStatus() == BMAP_STATUS_SUCCESS && position.latitude && position.longitude) {
                if (!position.accuracy) position.accuracy = 100;
                console.green('定位城市', position.address.city);
                myLoc = {
                    lat: position.latitude,
                    lng: position.longitude,
                    accuracy: position.accuracy,
                    bLoc: new BMap.Point(position.longitude, position.latitude),
                    address: position.address,
                };
                // 画点
                if (!mapData.succMarker) {
                    mapData.succMarker = new BMap.Marker(myLoc.bLoc, {
                        icon: new BMap.Icon("./static/img/plane.png", new BMap.Size(30, 30)),
                        title: "我的位置",
                        enableMassClear: false,
                    });
                    // _this.succMarker.disableMassClear();
                    mapData.succMarker.setTop(true);
                    myMap.map.addOverlay(mapData.succMarker);
                    // eslint-disable-next-line
                    mapData.succMarker.setAnimation(BMAP_ANIMATION_DROP);
                } else {
                    mapData.succMarker.setPosition(myLoc.bLoc);
                }
                // 范围
                if (!mapData.circle) {
                    mapData.circle = new BMap.Circle(myLoc.bLoc, myLoc.accuracy, {
                        fillColor: "rgba(144, 202, 249, 0.5)",
                        strokeColor: "rgba(144, 202, 249, 1)",
                        strokeWeight: 2,
                        enableMassClear: false,
                    });
                    // 如果范围在株洲 则第一次定位成功移动
                    if (position.address.city.indexOf("株洲") > -1) {
                        myMap.map.addOverlay(mapData.circle);
                        myMap.map.panTo(myLoc.bLoc);
                    }
                    //指南针
                    getNorth(mapData);
                } else {
                    mapData.circle.setCenter(myLoc.bLoc);
                    mapData.circle.setRadius(myLoc.accuracy);
                }
                if (position.address.city.indexOf("株洲") > -1) {
                    myMap.map.removeOverlay(mapData.noLocMarker);
                    mapStore.setMyLoc(myLoc);
                } else {
                    console.blue('定位成功 不在株洲');
                    window.mdui.snackbar({
                        message: '定位成功,但您好像不在株洲',
                    });
                    // err();
                }
                appStore.changeLocState(true);
            } else {
                console.red('定位失败');
                window.mdui.snackbar({
                    message: '定位失败',
                });
                // err();
                appStore.changeLocState(false);
            }
            //定位结束
            appStore.changeIsLocIng(false);
        }, {
            enableHighAccuracy: true,
            timeout: myConst.loc.timeout,
            maximumAge: myConst.loc.maximumAge,
        });
    };
    //开始定位
    myMap.geolocation.getLoc();

    // function err() {
    // 没定位到该咋办
    // }
}

// 我的坐标是指南针
function getNorth() {
    // 指针
    if (window.DeviceOrientationEvent) {
        // console.log('your browser is pefer to support DeviceOrientationEvent');
        window.addEventListener("deviceorientation", findNorth);
        // eslint-disable-next-line
        function getOrientationData(evt) {
            return {
                'alphaValue': evt.alpha,
                'betaValue': evt.beta,
                'gammaValue': evt.gamma,
            };
        }
        // eslint-disable-next-line
        function showInScreen(data) {
            if (data.alphaValue) {
                let deg = -data.alphaValue;
                mapData.succMarker.setRotation(deg);
            }
        }
        // eslint-disable-next-line
        function findNorth(evt) {
            let me = evt;
            showInScreen(getOrientationData(me));
        }
    } else {
        // tosi alert('you need to update your browser!');
    }
}

export function initEvent() {
    // 注册事件
    // console.log('mEvent', _this.myConst.mEvent)

    // myMap.map.addEventListener('longpress', (event) => {
    //     console.log('我长按了地图');
    // });

    // 计算每次移动地图后的中心点
    myMap.map.addEventListener('moveend', (event) => {
        let centerPoint = myMap.map.getCenter();
        let lastDistance = myMap.map.getDistance(mapData.lastCenterLoc, centerPoint);
        console.blue('movend lastDistance', myConst.minPinDis, lastDistance,
            `${mapData.lastCenterLoc.lat}-${mapData.lastCenterLoc.lng} => ${centerPoint.lat}-${centerPoint.lng}`);
        mapData.lastCenterLoc = centerPoint;
        // 如果移动范围大于 "30m" 重新 pin
        if (lastDistance >= myConst.minPinDis) {
            findAndPin(centerPoint);
        }
    });
    // 开始缩放地图
    myMap.map.addEventListener('zoomend', (event) => {
        mapStore.toggleInfoBox({ source: 'zoomend map', on_off: false });
        let zoomLevel = myMap.map.getZoom();
        if (zoomLevel >= myConst.HIDE_MARKER_TEXT_LEVEL) {
            mapStore.changeHideMarkerText(false);
        } else {
            mapStore.changeHideMarkerText(true);
        }
        myMap.map.dispatchEvent("moveend");
    });

    myMap.map.addEventListener('touchstart', (event) => {
        if (!myMap.map.myTouchEvent) myMap.map.myTouchEvent = {};
        myMap.map.myTouchEvent.tStart = event.pixel;
        // 左侧滑动拉出
        // _this.myVar.appTouch.tStart = event.pixel;
    });
    // click touchend
    myMap.map.addEventListener(myConst.mEvent, (event) => {
        //如果点击的地方有覆盖物
        if (event.overlay) {
            if (event.overlay.getLabel(".marker_icon")) { // getLable 无参数 此处参数仅为注释用
                let labelContent = event.overlay.getLabel().getContent();
                let _domId = labelContent.match(/markerId_.+_markerId/);
                if (!_domId) return;
                let labelDom = document.getElementById(_domId[0]);
                if (labelDom) {
                    let v = labelDom.parkingInfo; // 也许是空值
                    let i = 0;
                    // 找到单车点 ID - OBJ
                    if (!v) {
                        // 缓存到 dom 上，下次不用再找
                        let vId = labelDom.id.replace('markerId_', '').replace('_markerId', '');
                        let onMapList = dataStore.onMapList;
                        for (; i < onMapList.length; i++) {
                            if (onMapList[i].id == vId) {
                                v = onMapList[i];
                                labelDom.parkingInfo = v;
                                break;
                            }
                        }
                    }
                    mapStore.toggleInfoBox({
                        on_off: true,
                        detail: { v, i },
                    });
                }
            }
        } else {
            // 判断单击
            mapData.singleTap++;
            clearTimeout(mapData.mapClickEventTimer);
            mapData.mapClickEventTimer = setTimeout(() => {
                if (mapData.singleTap == 1) {
                    mapData.singleTap = 0;
                    if (myConst.isMobile) {
                        let tPoint = myMap.map.myTouchEvent;
                        tPoint.tEnd = event.pixel;
                        if (Math.abs(tPoint.tEnd.x - tPoint.tStart.x) < 10 && Math.abs(tPoint.tEnd.y - tPoint.tStart.y) < 10) {
                            // 点击事件
                            mapClose();
                        } else {
                            // 滑动事件
                        }
                    } else {
                        mapClose();
                    }
                } else {
                    mapData.singleTap = 0;
                }
            }, 300);
        }

        function mapClose() {
            if (appStore.appState.searchShow) {
                //
                // 如果有 searchShow -> 关
                //             |-> infoBox ->关
                //                    |-> 神马都没有 -> 全屏
                // searchShow
                appStore.toggleSearchShow({ on_off: false });
            } else {
                if (mapStore.win.infoBox._isOpen) {
                    // infoBox
                    mapStore.toggleInfoBox({ source: 'mapClose', on_off: false });
                } else {
                    // 全屏
                    // if (myConst.isMobile && navigator.userAgent.indexOf('UCBrowser') == -1) {
                    //     UTILS.toggleFullScreen();
                    //     if (!document.fullscreenElement && // alternative standard method
                    //         !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) { // current working methods
                    //         $$("#map .BMap_noprint.anchorTR").removeClass('hide');
                    //         $$("#map .BMap_stdMpCtrl.BMap_noprint.anchorBR").removeClass('hide');
                    //         $$("#iLoc").removeClass('hide');
                    //         $$("#floatBtn").removeClass('mdui-fab-hide');
                    //     } else {
                    //         $$("#map .BMap_noprint.anchorTR").addClass('hide');
                    //         $$("#map .BMap_stdMpCtrl.BMap_noprint.anchorBR").addClass('hide');
                    //         $$("#iLoc").addClass('hide');
                    //         $$("#floatBtn").addClass('mdui-fab-hide');
                    //     }
                    // }
                }
            }
        }
    });
}
